// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inputDialogRoot[data-v-3aff1ede]
	{
		max-width: 300px;
		background-color: #FFFFFF;
}
.checkbox[data-v-3aff1ede]
	{
		font-size: 15px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-bottom: 5px;
}
.checkbox label[data-v-3aff1ede]
		{
}
.titleBar[data-v-3aff1ede]
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
}
.title[data-v-3aff1ede]
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
}
.messageText[data-v-3aff1ede]
	{
		margin: 8px 14px;
		white-space: pre-wrap;
}
.dialogBody[data-v-3aff1ede]
	{
		padding: 0px 5px 0px 5px;
}
.inputWrapper[data-v-3aff1ede]
	{
		display: flex;
}
.colorInput[data-v-3aff1ede]
	{
		flex: 1 1 auto;
		margin: 10px 15px;
		border: 1px solid #AAAAAA;
		border-radius: 3px;
		padding: 3px 6px;
		font-size: 13pt;
}
.buttons[data-v-3aff1ede]
	{
		display: flex;
}
.dialogButton[data-v-3aff1ede]
	{
		display: inline-block;
		cursor: pointer;
		color: black;
		font-weight: bold;
		font-size: 12pt;
		box-sizing: border-box;
		position: relative;
		padding: 12px 5px;
		flex: 1 0 auto;
		text-align: center;
}
.dialogButton[data-v-3aff1ede]:hover
		{
			background-color: rgba(0,0,0,0.05);
}
.okButton[data-v-3aff1ede]
	{
		color: #4A9E42;
}
.cancelButton[data-v-3aff1ede]
	{
		color: #CE7D29;
		border-left: 1px solid #DDDDDD;
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/controls/ColorInputPopup.vue"],"names":[],"mappings":";AA+EC;;EAEC,gBAAgB;EAChB,yBAAyB;AAC1B;AAEA;;EAEC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACnB;AAEC;;AAEA;AAED;;EAEC,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACvB;AAEA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAChB;AAEA;;EAEC,gBAAgB;EAChB,qBAAqB;AACtB;AAEA;;EAEC,wBAAwB;AACzB;AAEA;;EAEC,aAAa;AACd;AAEA;;EAEC,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AAChB;AAEA;;EAEC,aAAa;AACd;AAEA;;EAEC,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACnB;AAEC;;GAEC,kCAAkC;AACnC;AAED;;EAEC,cAAc;AACf;AAEA;;EAEC,cAAc;EACd,8BAA8B;AAC/B","sourcesContent":["<template>\r\n\t<div :class=\"{ inputDialogRoot: true }\" ref=\"dialogRoot\" role=\"dialog\" aria-labelledby=\"textInputMsgTitle\" aria-describedby=\"colorInputMsg\">\r\n\t\t<div v-if=\"title\" class=\"titleBar\">\r\n\t\t\t<div id=\"textInputMsgTitle\" class=\"title\" role=\"alert\">{{title}}</div>\r\n\t\t</div>\r\n\t\t<div class=\"dialogBody\">\r\n\t\t\t<div id=\"colorInputMsg\" class=\"messageText\" v-if=\"message\">{{message}}</div>\r\n\t\t\t<div class=\"inputWrapper\">\r\n\t\t\t\t<input type=\"color\" ref=\"inputColor\" v-model=\"value\" @keypress.enter=\"okClicked\" class=\"colorInput\" />\r\n\t\t\t</div>\r\n\t\t\t<div class=\"buttons\">\r\n\t\t\t\t<div class=\"dialogButton okButton\" tabindex=\"0\" @click=\"okClicked\" @keydown.space.enter.prevent=\"okClicked\">\r\n\t\t\t\t\tOK\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"dialogButton cancelButton\" tabindex=\"0\" @click=\"cancelClicked\" @keydown.space.enter.prevent=\"cancelClicked\">\r\n\t\t\t\t\tCancel\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\tlet animationEvents = [\"webkitAnimationEnd\", \"oanimationend\", \"msAnimationEnd\", \"animationend\"];\r\n\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\ttitle: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: null\r\n\t\t\t},\r\n\t\t\tmessage: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t},\r\n\t\t\tinitialColor: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"FF0000\"\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tvalue: \"#FF0000\",\r\n\t\t\t\tchecked: false\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t\tif (this.initialColor && this.initialColor.length === 6)\r\n\t\t\t\tthis.value = \"#\" + this.initialColor;\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tSetFocus()\r\n\t\t\t{\r\n\t\t\t\tif (this.$refs.inputColor)\r\n\t\t\t\t\tthis.$refs.inputColor.focus();\r\n\t\t\t},\r\n\t\t\tDefaultClose()\r\n\t\t\t{\r\n\t\t\t},\r\n\t\t\tokClicked()\r\n\t\t\t{\r\n\t\t\t\tlet color = this.value;\r\n\t\t\t\tif (color.indexOf('#') === 0)\r\n\t\t\t\t\tcolor = color.substr(1);\r\n\t\t\t\tthis.$emit(\"close\", { value: color });\r\n\t\t\t},\r\n\t\t\tcancelClicked()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"close\");\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.inputDialogRoot\r\n\t{\r\n\t\tmax-width: 300px;\r\n\t\tbackground-color: #FFFFFF;\r\n\t}\r\n\r\n\t.checkbox\r\n\t{\r\n\t\tfont-size: 15px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row;\r\n\t\tjustify-content: center;\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\r\n\t\t.checkbox label\r\n\t\t{\r\n\t\t}\r\n\r\n\t.titleBar\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 8px 14px;\r\n\t\tbox-sizing: border-box;\r\n\t}\r\n\r\n\t.title\r\n\t{\r\n\t\ttext-align: center;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 16pt;\r\n\t}\r\n\r\n\t.messageText\r\n\t{\r\n\t\tmargin: 8px 14px;\r\n\t\twhite-space: pre-wrap;\r\n\t}\r\n\r\n\t.dialogBody\r\n\t{\r\n\t\tpadding: 0px 5px 0px 5px;\r\n\t}\r\n\r\n\t.inputWrapper\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.colorInput\r\n\t{\r\n\t\tflex: 1 1 auto;\r\n\t\tmargin: 10px 15px;\r\n\t\tborder: 1px solid #AAAAAA;\r\n\t\tborder-radius: 3px;\r\n\t\tpadding: 3px 6px;\r\n\t\tfont-size: 13pt;\r\n\t}\r\n\r\n\t.buttons\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.dialogButton\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tcursor: pointer;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 12pt;\r\n\t\tbox-sizing: border-box;\r\n\t\tposition: relative;\r\n\t\tpadding: 12px 5px;\r\n\t\tflex: 1 0 auto;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t\t.dialogButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.05);\r\n\t\t}\r\n\r\n\t.okButton\r\n\t{\r\n\t\tcolor: #4A9E42;\r\n\t}\r\n\r\n\t.cancelButton\r\n\t{\r\n\t\tcolor: #CE7D29;\r\n\t\tborder-left: 1px solid #DDDDDD;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
